import { SubscriptionState } from '../../types';
import * as types from './types';

export const setUserSubscriptions = (payload: SubscriptionState) => {
  return {
    type: types.SET_USER_SUBSCRIPTIONS,
    payload,
  };
};

export const resetUserSubscriptions = () => {
  return {
    type: types.RESET_USER_SUBSCRIPTIONS,
  };
};
